module.exports = __webpack_public_path__ + "static/media/Nardie-Scharenborg-CTO-CIO-SSC-ICT.b9436a0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Nardie-Scharenborg-CTO-CIO-SSC-ICT.jpg
// module id = 189
// module chunks = 0